{
  "common": {
    "cancel": "Bekor qilish",
    "close": "Yopish",
    "delete": "O'chirish",
    "edit": "Tahrirlash",
    "save": "Saqlash",
    "show": "Ko'rsatish",
    "hide": "Yashirish",
    "search": "Qidirish…",
    "clearSearch": "Qidiruvni yopish",
    "noMatch": "Hech narsa topilmadi",
    "retry": "Qayta urinish"
  },
  "page": {
    "preview": "Ko’rish",
    "save": "Saqlash",
    "saveHint": "Saqlash (Ctrl+S)",
    "loading": "Yuklanmoqda…",
    "loadError": "Bosh panelni yuklab bo'lmadi"
  },
  "save": {
    "success": "Saqlandi",
    "successHint": "O'zgarishlar barcha foydalanuvchilarga ko'rinadi",
    "error": "Saqlab bo'lmadi",
    "unknownSection": "Belgi bog'langan bo'lim topilmadi",
    "conflictTitle": "Sahifa boshqa foydalanuvchi tomonidan o'zgartirilgan",
    "conflictTextBy": "{{name}} {{time}} da yangi versiyani saqladi. Oxirgi versiyani qayta yuklashingiz yoki o'z o'zgarishlaringizni ustiga yozishingiz mumkin.",
    "conflictText": "Sahifaning yangi versiyasi {{time}} da saqlangan. Oxirgi versiyani qayta yuklashingiz yoki o'z o'zgarishlaringizni ustiga yozishingiz mumkin.",
    "reload": "Qayta yuklash",
    "overwrite": "Ustiga yozish",
    "reloaded": "Oxirgi versiya yuklandi",
    "linksDropped": "O'chirilgan bo'limga bog'lanish olib tashlandi: {{names}}",
    "unknownSectionHint": "Belgi sozlamalarida bo'limni qayta tanlang: {{names}}"
  },
  "unsaved": {
    "title": "Saqlanmagan o'zgarishlar bor. Chiqasizmi?",
    "text": "Saqlamasdan chiqsangiz, kiritilgan o'zgarishlar yo'qoladi.",
    "save": "Saqlash",
    "discard": "Saqlamasdan chiqish",
    "stay": "Sahifada qolish"
  },
  "preview": {
    "back": "Tahrirlashga qaytish",
    "label": "{{title}} — ko'rish rejimi"
  },
  "types": {
    "background": "Fon",
    "clock": "Soat",
    "date": "Sana",
    "indicator": "Ko’rsatkich",
    "title": "Sarlavha",
    "marker": "Belgi",
    "image": "Rasm",
    "gif": "GIF",
    "video": "Video",
    "sectionGrid": "Bo’limlar"
  },
  "popoverTitles": {
    "background": "Fon",
    "clock": "Soat",
    "date": "Sana",
    "indicator": "Ko'rsatkich",
    "title": "Sarlavha",
    "marker": "Belgi",
    "image": "Rasm",
    "gif": "GIF",
    "video": "Video"
  },
  "rail": {
    "label": "Vidjetlar",
    "hint": "{{name}} — bosib sozlang yoki chizmaga sudrab qo'shing",
    "backgroundHint": "Fon — bosh panel foni"
  },
  "canvas": {
    "label": "Bosh panel chizmasi",
    "roledescription": "tahrirlash maydoni",
    "emptyTitle": "Hali vidjet qo'shilmagan",
    "emptyText": "O'ngdagi “Vidjetlar” bo'limidan vidjet tanlab, chizmaga qo'shing",
    "zoomIn": "Kattalashtirish",
    "zoomOut": "Kichiklashtirish",
    "fit": "Ekranga moslash",
    "zoom100": "100% ko'rsatish",
    "zoomLevel": "Masshtab {{value}}%",
    "locked": "Qulflangan"
  },
  "menu": {
    "duplicate": "Nusxa olish",
    "forward": "Oldinga",
    "backward": "Orqaga",
    "paste": "Joylashtirish"
  },
  "elements": {
    "title": "Elementlar",
    "search": "Elementlarni qidirish",
    "add": "Element qo'shish",
    "empty": "Elementlar mavjud emas",
    "emptyHint": "Hali elementlar yo'q.",
    "lock": "Qulflash",
    "unlock": "Qulfdan chiqarish",
    "rename": "Nomini o'zgartirish",
    "reorderHint": "Tartibni o'zgartirish uchun sudrang yoki Alt + ↑ / ↓ bosing. Ikki marta bosib nomini o'zgartiring.",
    "deleted": "“{{name}}” o'chirildi",
    "undo": "Qaytarish"
  },
  "sections": {
    "title": "Bo’limlar",
    "search": "Bo'limlarni qidirish",
    "add": "Bo'lim qo'shish",
    "count": "{{count}} dona ko’rsatkich",
    "empty": "Bo’limlar mavjud emas",
    "emptyHint": "Hali Bo’limlar yo'q. \"Bo'lim qo'shish\" tugmasini bosib yangi bo'lim yarating.",
    "loadError": "Bo'limlarni yuklab bo'lmadi",
    "saveError": "O'zgarishni saqlab bo'lmadi",
    "deleteTitle": "Bo'limni o'chirish",
    "deleteText": "“{{name}}” bo'limi, uning papkalari, chizmalari va ko'rsatkichlari o'chiriladi.",
    "deleted": "Bo'lim o'chirildi",
    "deleteError": "Bo'limni o'chirib bo'lmadi",
    "reorderHint": "Kartalar tartibini o'zgartirish uchun sudrang yoki Alt + ↑ / ↓ bosing. Nomini bosib bo'lim sozlamasini oching."
  },
  "sectionModal": {
    "createTitle": "Yangi bo'lim",
    "createSubtitle": "Monitoring sahifasi qo'shish",
    "editTitle": "Bo'limni tahrirlash",
    "editSubtitle": "Monitoring sahifasi sozlamalari",
    "name": "Bo'lim nomi",
    "namePlaceholder": "Masalan: Klinometr",
    "nameRequired": "Bo'lim nomini kiriting",
    "nameTaken": "Bunday nomli bo'lim mavjud",
    "icon": "Ikonka",
    "uploadIcon": "Ikonka yuklash",
    "uploadIconHint": "SVG yoki PNG, 256 KB gacha, kamida 48×48 px",
    "iconType": "Ikonka faqat SVG yoki PNG bo'lishi mumkin",
    "iconTooBig": "Ikonka hajmi 256 KB dan oshmasligi kerak",
    "iconTooSmall": "Ikonka kamida 48×48 px bo'lishi kerak",
    "cardMode": "Kartada nima ko'rsatilsin",
    "modeFull": "Ikonka, nom, son",
    "modeName": "Faqat nom",
    "countSource": "Son manbai",
    "countAuto": "Avtomatik",
    "countManual": "Qo'lda",
    "manualCount": "Qo'lda son kiriting",
    "manualCountHint": "dona (qo'lda belgilangan qiymat)",
    "countInvalid": "0 dan 999 999 gacha butun son kiriting",
    "create": "Bo'lim qo'shish",
    "created": "Bo'lim qo'shildi",
    "updated": "Bo'lim saqlandi",
    "limit": "Bo'limlar soni chegarasiga yetildi (50)",
    "saveError": "Bo'limni saqlab bo'lmadi"
  },
  "popover": {
    "close": "Yopish",
    "drag": "Panelni surish",
    "add": "Qo’shish",
    "deleteWidget": "Vidjetni o'chirish",
    "scale": "O'lcham",
    "decrease": "kamaytirish",
    "increase": "oshirish"
  },
  "empty": {
    "clock": {
      "title": "Soat qo’shish",
      "text": "Soat vidjetini qo'shing"
    },
    "date": {
      "title": "Sana qo’shish",
      "text": "Sana vidjetini qo'shing"
    },
    "indicator": {
      "title": "Ko'rsatkich qo’shish",
      "text": "Ko'rsatkich vidjetini qo'shing"
    },
    "title": {
      "title": "Sarlavha qo’shish",
      "text": "Sarlavha vidjetini qo'shing"
    },
    "marker": {
      "title": "Belgi qo’shish",
      "text": "Belgi vidjetini qo'shing"
    },
    "image": {
      "title": "Rasm qo’shish",
      "text": "Rasm vidjetini qo'shing"
    },
    "gif": {
      "title": "GIF qo’shish",
      "text": "GIF vidjetini qo'shing"
    },
    "video": {
      "title": "Video qo’shish",
      "text": "Video vidjetini qo'shing"
    }
  },
  "clock": {
    "seconds": "Sekundlarni ko'rsatish"
  },
  "date": {
    "format": "Format"
  },
  "indicator": {
    "icon": "Ikonka",
    "source": "Qiymat manbai",
    "manual": "Qo'lda",
    "pick": "Tanlash",
    "name": "Nom",
    "value": "Qiymat",
    "unit": "Birlik",
    "sensor": "Qurilma",
    "sensorPlaceholder": "Qurilmani tanlang",
    "sensorSearch": "Qurilma yoki ko'rsatkichni qidiring",
    "sensorsLoading": "Qurilmalar yuklanmoqda…",
    "noSensors": "Qurilmalar topilmadi"
  },
  "title": {
    "title": "Sarlavha",
    "titlePlaceholder": "Sarlavha yozing",
    "titleSize": "Sarlavha o'lchami",
    "subtitle": "Taglavha",
    "subtitlePlaceholder": "Obyekt nomi yozing",
    "subtitleSize": "Taglavha o'lchami",
    "accentBar": "Chap chiziqni ko'rsatish",
    "logo": "Logotipni ko'rsatish",
    "logoHint": "Ko'rish rejimida sarlavha oldida"
  },
  "marker": {
    "name": "Nom",
    "link": "Bo'limga bog'lash",
    "noLink": "Yo'q",
    "side": "Yorliq tomoni",
    "sideAuto": "Avto",
    "sideLeft": "Chap",
    "sideRight": "O'ng"
  },
  "media": {
    "upload": {
      "image": "Rasm yuklash",
      "gif": "GIF yuklash",
      "video": "Video yuklash"
    },
    "aspect": "Kadr nisbati",
    "width": "Kenglik",
    "zoom": "Kattalashtirish",
    "autoplay": "Avtomatik ijro (ovozsiz)",
    "loop": "Takroriy ijro",
    "replace": "Almashtirish",
    "remove": "Faylni olib tashlash",
    "uploading": "Yuklanmoqda…",
    "uploadError": "Faylni yuklab bo'lmadi",
    "tooLarge": "Fayl hajmi {{max}} dan oshmasligi kerak",
    "badType": "Bu turdagi fayl qabul qilinmaydi",
    "noRight": "Fayl yuklash uchun huquqingiz yo'q",
    "meta": "{{w}} × {{h}} px · {{size}}"
  },
  "background": {
    "emptyTitle": "Fon qo’shish",
    "emptyText": "Fon vidjetini qo'shing",
    "upload": "Fayl yuklash",
    "opacity": "Shaffoflik",
    "scale": "Kattalashtirish",
    "remove": "Fonni o'chirish",
    "removeTitle": "Fonni o'chirish",
    "removeText": "Fon fayli bosh paneldan olib tashlanadi. Saqlashdan oldin Ctrl+Z bilan qaytarish mumkin.",
    "type": "Fon turi",
    "typeImage": "Rasm",
    "typeVideo": "Video",
    "typeGif": "GIF"
  }
}
